import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { equals } from 'ramda'

const DEFAULT_ICON = '/assets/Apple.svg'

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2vh;
  width: 250px;
  background-color: ${props => props.isSelected ? '#3b99fc' : '#E2E8EC'};
  border-radius: 8px;
  margin: 1vh 0 1vh 0;
  cursor: pointer;
`
const ButtonLabel = styled.div`
  width: 60%;
  color: ${props => props.isSelected ? '#FFF' : '#4A4A4A'};
`
const ButtonIcon = styled.img`
  margin-right: 1vh;
  width: 30px;
  height: 30px;

  @media (max-width:1024px) {
    width: 25px;
    height: 25px;
    margin-right: 10px;
  }

  @media (max-width:900px) {
    width: '40px';
    height: '40px';
    margin-right: 5px;
  }
`
const HiddenInput = styled.input`
  display: none;
`

class MealButton extends Component {
  state = {
    icon: DEFAULT_ICON,
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ icon: nextProps.icon || DEFAULT_ICON })
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (equals(this.props, nextProps) && equals(this.state, nextState)) return false

    return true
  }

  simulateInputClick = () => this.textInput.click()

  render() {
    const { id, isSelected, label, name, onClick } = this.props

    return (
      <ButtonContainer
        isSelected={isSelected}
        onClick={this.simulateInputClick}
      >
        <ButtonIcon src={this.state.icon} />
        <ButtonLabel isSelected={isSelected}>{label}</ButtonLabel>
        <HiddenInput
          id={id}
          name={name}
          innerRef={(input) => { this.textInput = input }}
          onClick={onClick}
        />
      </ButtonContainer>
    )
  }
}

MealButton.propTypes = {
  /** The unique ID for the button */
  id: PropTypes.string.isRequired,
  /** The icon to be displayed in the button */
  icon: PropTypes.string,
  /** Flag marking whether the button has been selected */
  isSelected: PropTypes.bool,
  /** The text label displayed on the button */
  label: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  /** The name of the button */
  name: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  /** Callback function to be fired when clicking the button */
  onClick: PropTypes.func.isRequired,
}

MealButton.defaultProps = {
  icon: DEFAULT_ICON,
  isSelected: false,
}

export default MealButton



// WEBPACK FOOTER //
// ./src/Components/CustomButtons/MealButton.jsx